<template>
  <div>
    <div class="up-file-button" @click="upFile">{{fileStatus}}</div>
    <input type="file" ref="file" @change="changFile" style="display:none" />
    <div class="up-file-modle" v-if="lanList">
        <div class="file-content">
            <div class="file-name">
                <div class="file-del" @click="closeLanList"></div>
                <div class="file-title">
                    <img src="../assets/file-icon.png" alt="">
                    <p class="_file-name">{{file['name']}}</p>
                    <p class="_file-des">{{file['_size']}}</p>
                </div>
                <p>{{$t('filebutton.message')}}</p>
            </div>
        </div>
        <div v-bind:class="['lan-list',{'show-list':lanList}]">
            <div class="lan-item" v-for="(item,index) in lanData"
                 @click="changeTrans(item)"
                 :key="index">{{item.text}}</div>
            <div class="lan-cal" @click="closeLanList">取&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;消</div>
        </div>
    </div>
  </div>
  
</template>
<style scoped>
    .up-file-button{
        color: #FFFFFF;
        width: 100%;
        padding: 15.5px 0;
        background-color: #05BA7E;
        position: fixed;
        bottom: 0;
        text-align: center;
        vertical-align: middle;
        font-weight: bold;
        z-index: 100;
    }
    .up-file-modle{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom:0;
        z-index: 10000;
        background: rgba(0,0,0,0.6);
    }
    .lan-list{
        position: absolute;
        width: 100%;
        bottom: 0;
        background-color: #efeff4;
        color: #333;
        display: none;
    }
    .lan-list.show-list{
        display: block;
    }
    .lan-list >div{
        position: relative;
        padding: 15px 0;
        text-align: center;
        font-size: 16px;
        background-color: #fcfcfd;
    }
    .lan-list >div.lan-item:before {
        content: " ";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        height: 1px;
        border-top: 1px solid #e5e5e5;
        color: #e5e5e5;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        -webkit-transform: scaleY(.5);
        transform: scaleY(.5);
    }
    .lan-list >div.lan-cal{
        margin-top: 6px;
    }
    .file-name{
        position: absolute;
        left: 18px;
        right: 18px;
        padding: 30px;
        top: 40%;
        transform: translateY(-50%);
        background: #FFFFFF;
        border-radius: 4px;
    }
    .file-title{
        position: relative;
        padding-left: 85px;
        margin-top: 10px;
    }
    .file-title >img{
        position: absolute;
        width: 27px;
        height: 32px;
        display: block;
        left: 40px;
        top: 5px;
    }
    .file-title >p{
        margin: 0;
        padding:0;
    }
    .file-title>p._file-name{
        font-size: 14px;
        color: #05BA7E;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 150px;
        margin-bottom: 10px;
    }
    .file-title>p._file-des{
        font-size: 12px;
        color: #8c8c8c;
    }
    .file-name>p{
        margin: 0;
        padding:0;
        margin-top: 40px;
        font-size: 12px;
        color: #999999;
        text-align: center;
    }
    .file-del{
        position: absolute;
        top: 10px;
        right: 10px;
        width: 16px;
        height: 16px;
        background: url(../assets/alert-close-icon.png) no-repeat;
        background-size: 16px 16px;
        background-repeat: no-repeat;
        background-position: center;
    }
</style>
<script>
    import { fileSizeNum } from '@/api/public';
    import {postFile} from '@/api/doc';
    import { getTranslator,USER_INFO } from '@/api/user';

    const wordlogo = require("../assets/doc-icon.png");
    const pdflogo = require("../assets/pdf-icon.png");
    const MAXFILE = 20;

    export default {
    name: "UpFileButton",
    data() {
      return {
          file:{},
          lanList:false,
          fileStatus:this.$t('filebutton.button[0]'),
          lanData:[
              {
                  text:this.$t('filebutton.text[0]'),
                  transType:'zh2en'
              },
             {
                  text:this.$t('filebutton.text[1]'),
                  transType:'en2zh'
              },
              {
                  text:this.$t('filebutton.text[2]'),
                  transType:'zh2ja'
              },
              {
                  text:this.$t('filebutton.text[3]'),
                  transType:'ja2zh'
              }
          ],
          user:{},
          trans_type:'auto',
          isUping:false
      };
    },
    mounted (){
    },
    created(){
        this.user = USER_INFO({})||{};
    },
    methods: {
        upFile:function(){
            if(this.isUping){
                return;
            }
            this.$refs.file.click();
        },
        changFile:function(e){
            const file =e.target.files[0] || {};
            if(!file){
               return;
            }
            const fileType = file.type || '';
            if(fileType !=='application/pdf' && fileType !=='application/vnd.openxmlformats-officedocument.wordprocessingml.document'){
               this.showErrorMessage(`${this.$t('fanyi.message.format')}`);
               return;
            }
            
            if (file['size'] > (MAXFILE * 1024 * 1024)) {
                this.showErrorMessage(`${this.$t('fanyi.message.size_a')}` + MAXFILE + `${this.$t('fanyi.message.size_b')}` );
                return;
            }

            file['_size'] = fileSizeNum(file.size);
            this.file = file;
            this.lanList = true;
        },
        closeLanList:function(){
            this.info();
        },
        info:function(){
            this.file = {};
            this.lanList = false;
            this.trans_type = 'auto';
            this.fileStatus = this.$t('filebutton.button[0]');
            this.isUping = false;
        },
        showErrorMessage:function(err){
            this.$message({
                type: 'error',
                message: err
            });
            this.info();
        },
        changeTrans:function(item){
            if(!this.file){
                return;
            }
            if(this.isUping == true){
                return ;
            }
            this.isUping = true;
            let fileType = this.file.type || '';
            this.trans_type = item.transType || 'auto';
            if(fileType =='application/pdf'){
                fileType = 'pdf'
                this.file['doc_img'] = pdflogo;
            }else if(fileType =='application/vnd.openxmlformats-officedocument.wordprocessingml.document'){
                fileType = 'doc';
                this.file['doc_img'] = wordlogo;
            } else{
                this.showErrorMessage(`${this.$t('fanyi.message.format')}`);
                return;
            }

            this.file['_type'] = fileType;
            this.file['_trans_type'] = this.trans_type;
            this.fileStatus = this.$t('filebutton.button[1]');
            postFile(this.file,this.trans_type,this.user._id,(e)=>{ 
                let num = Math.round((e.loaded / e.total) * 100);
                this.lanList = false;
                this.$emit('updata',{
                    status:'progress',
                    file:this.file,
                    progress:num
                });
            }).then(res=>{
                const data = res.data;
                this.isUping = true;
                if(data.rc == 0){
                   this.info();
                   this.$emit('updata',{
                       status:'ok'
                   });
                }else{
                     if (data.rc == -1){
                        this.showErrorMessage(`${this.$t('fanyi.message.format')}`);
                    } else if (data.rc == -2 ){
                        this.showErrorMessage(`${this.$t('fanyi.message.ts_error')}`);
                    } else {
                        this.showErrorMessage(`${this.$t('fanyi.message.up_error')}`);
                    }
                }
            })
        }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/UpFileButton.vue